import { Box, Button } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import PatientForm from '../../client/modules/patient/components/PatientModal/components/PatientForm'
import { useAccount } from '../../client/modules/account/AccountProvider'
import BasePageLayout from '../../client/modules/common/components/BasePageLayout'
import { useIntl } from 'react-intl'

export default function CreatePatient() {
  const navigate = useNavigate()
  const { schema } = useAccount()
  const { formatMessage } = useIntl()

  return (
    <BasePageLayout
      title={formatMessage({
        id: 'internalNav.newPatient',
        defaultMessage: 'New patient'
      })}
    >
      <Box maxW="900px" mx="auto" p={{ base: 2, md: 6 }}>
        <Button
          leftIcon={<ArrowLeftIcon style={{ width: '16px', height: '16px' }} />}
          variant="ghost"
          mb={6}
          onClick={() => {
            navigate(-1)
          }}
        >
          {formatMessage({ id: 'common.back', defaultMessage: 'Back' })}
        </Button>
        <PatientForm
          historySchema={schema.history}
          isEditMode={false}
          onClose={() => {
            navigate(-1)
          }}
        />
      </Box>
    </BasePageLayout>
  )
}
